import Button from '@material-ui/core/Button'
import React from 'react'
import { useStyles } from '../pages/styled'

import CircularProgress from '@material-ui/core/CircularProgress'

type ButtonSimplyProps = {
  children: any
  props?: any
  onClick: () => void
  loading?: boolean
}

const OrdinaryButton = ({
  children,
  props,
  onClick,
  loading = true,
}: ButtonSimplyProps) => {
  const classes = useStyles()
  return loading ? (
    <Button
      type="button"
      onClick={onClick}
      className={classes.uploadButton}
      {...props}
    >
      {children}
    </Button>
  ) : (
    <CircularProgress />
  )
}

export default OrdinaryButton
